module.exports = __webpack_public_path__ + "static/media/Sports.99dd52de.png";